window.jQuery = window.$ = require('jquery');
require('bootstrap');
require('popper.js');

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import localeData from 'dayjs/plugin/localeData'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import plLocale from 'dayjs/locale/pl'
import enLocale from 'dayjs/locale/en'

import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'

dayjs.extend(utc)
dayjs.extend(localeData)
dayjs.extend(localizedFormat)
dayjs.extend(isSameOrAfter)

const LOCALE = document.documentElement.lang || 'pl'

const TRANSLATIONS = {
  en: {
    no_free_slots: 'No available places',
    free_slots: 'Available places',
    instructors: 'Instructors',
    venue: 'Location',
    proficiency: 'Proficiency',
    timing: 'Timing'
  },
  pl: {
    no_free_slots: 'Brak wolnych miejsc',
    free_slots: 'Są wolne miejsca',
    instructors: 'Prowadzący',
    venue: 'Miejsce',
    proficiency: 'Poziom',
    timing: 'Termin'
  }
}

class CalendarShowController {
  constructor() {
    dayjs.locale(LOCALE)
    this.isMobile = $(window).width() < 768
    this.origin = new URL(window.location.href).origin
    this.selector = '.calendar'
    this.calendar = $(this.selector)
    this.hideGroupSize = document.getElementById('js-hide-group-size') != null
    this.calendar.empty()

    this.filters = this.getDefaultFilters()
    this.defaultView = this.getDefaultView()
    this.minimalSignupDate = this.getMinimalSignupDate()
    this.initialize()
    this.refreshControls()
    this.bindEvents()
  }

  // Initial state

  getDefaultView() {
    if (this.isMobile && this.calendar.data('defaultView') !== 'listWeek') {
      return 'timeGridDay'
    } else {
      return this.calendar.data('defaultView')
    }
  }

  getMinimalSignupDate() {
    const startAfterEl = document.getElementById('signup_form_start_after')
    return startAfterEl?.value ? dayjs(startAfterEl.value) : null
  }

  getDefaultFilters() {
    const filters = {}
    if (this.calendar.data('proficiency')) {
      filters['proficiency'] = this.calendar.data('proficiency')
    }
    if (this.calendar.data('venue')) {
      filters['venueId'] = this.calendar.data('venue')
    }
    return filters
  }

  initialize() {
    this.fullCalendar = new Calendar(document.querySelector(this.selector), {
      timeZone: 'UTC',
      firstDay: 1,
      locale: LOCALE,
      events: this.loadAndFilterEvents.bind(this),
      allDaySlot: false,
      selectable: false,
      selectMirror: false,
      initialDate: this.calendar.data('dafaultDate'),
      initialView: this.defaultView,
      headerToolbar: false,
      height: 'auto',
      dayHeaderContent: (info) => {
        const date = dayjs(info.date)
        const view = info.view.type
        return view === 'listWeek'
          ? this.listHeaderContent(date)
          : this.basicHeaderContent(date, view)
      },
      nowIndicator: true,
      slotEventOverlap: false,
      slotDuration: this.calendar.data('slotDuration') || '00:30:00',
      slotLabelFormat: this.timeFormat(),
      eventTimeFormat: this.timeFormat(),
      slotMinTime: this.calendar.data('openTime') || '06:00',
      slotMaxTime: this.calendar.data('closeTime') || '24:00',
      weekends: this.calendar.data('showWeekends'),
      now: this.formatCurrentTime.bind(this),
      eventClick: this.eventClickFunction.bind(this),
      eventDidMount: this.eventDidMount.bind(this),
      eventContent: this.eventContent.bind(this),
      eventDisplay: 'block',
      plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin ]
    })
    this.fullCalendar.render()
  }

  timeFormat() {
    return {
      hour12: LOCALE !== 'pl',
      hour: 'numeric',
      minute: '2-digit'
    }
  }

  formatCurrentTime() {
    return dayjs().utc().format()
  }

  // Event Rendering
  eventContent(info) {
    const viewType = info.view.type
    const container = this.eventContainerHTML(info, viewType)
    const date = this.eventDateHTML(info, viewType)
    const title = this.eventTitleHTML(info, viewType)

    if (viewType === 'dayGridMonth') {
      date.style.paddingTop = '6px'
      container.append(date, title)
    } else {
      container.append(title, date)
      if (viewType !== 'listWeek') {
        const mask = this.eventMaskHTML()
        container.append(mask)
      }
    }

    return { domNodes: [container] }
  }

  eventContainerHTML(info, viewType) {
    const container = document.createElement(viewType === 'listWeek' ? 'a' : 'div')
    if (viewType === 'listWeek') {
      container.href = info.event.url
    } else {
      container.classList.add('fc-content')
    }
    container.style.overflow = 'hidden'
    return container
  }

  eventDateHTML(info, viewType) {
    const date = document.createElement(this.eventElementHTMLType())
    date.classList.add('fc-event-time')
    date.innerHTML = info.timeText
    date.style.alignItems = 'flex-start'

    const hours = date.textContent
    if (viewType === 'dayGridMonth' && hours && hours.indexOf(':') === -1) {
      date.textContent = hours + ':00'
    }
    return date
  }

  eventTitleHTML(info, viewType) {
    const title = document.createElement(this.eventElementHTMLType(viewType))
    title.classList.add('fc-event-title')
    title.innerHTML = info.event.title

    if (info.event.extendedProps.cancelled) {
      title.style.textDecoration = 'line-through'
    }

    if (info.event.end) {
      const eventStart = dayjs(info.event.start)
      const eventEnd = dayjs(info.event.end)
      if (eventEnd.diff(eventStart, 'hour') < 2) {
        title.style.whiteSpace = 'nowrap'
      }
    }

    title.style.fontWeight = '500'
    title.style.fontAlign = 'left'
    return title
  }

  eventMaskHTML() {
    const mask = document.createElement('div')
    mask.classList.add('fc-event-mask')
    return mask
  }

  eventElementHTMLType(viewType) {
    return viewType === 'dayGridMonth' ? 'span' : 'div'
  }

  updateCurrentDateHTML() {
    const date = dayjs(this.fullCalendar.getDate()).utc()

    let dateText
    switch (this.fullCalendar.view.type) {
      case 'timeGridDay':
        dateText = date.format('D MMMM YYYY')
        break
      case 'timeGridWeek':
      case 'listWeek':
        dateText = date.startOf('week').month() === date.endOf('week').month()
          ? date.startOf('week').format('MMMM YYYY')
          : `${date.startOf('week').format('MMM')} - ${date.endOf('week').format('MMM YYYY')}`
        break
      case 'dayGridMonth':
        dateText = date.format('MMMM YYYY')
        break
    }

    document.querySelector('.js-current-date').textContent = dateText
  }

  eventDidMount(info) {
    const isTouchDevice = matchMedia('(hover: none), (pointer: coarse)').matches
    if (!isTouchDevice) {
      $(info.el).tooltip({
        title: this.tooltipText(info.event),
        html: true
      })
    }
    this.eventAfterRender(info)
    this.eventAfterAllRenderFunction()
  }

  eventAfterRender(info) {
    const el = info.el
    el.style.borderTopWidth = '2px'
    el.style.borderTopStyle = 'solid'
    const mainFrame = el.querySelector('.fc-event-main-frame')
    if (mainFrame) {
      mainFrame.style.alignItems = 'flex-start'
    }
  }

  eventAfterAllRenderFunction() {
    this.sendResizeCallback()
    if (this.calendar.data('enableClickForSignup')) {
      document.querySelectorAll('.fc-event').forEach(event => {
        event.classList.add('cursor-pointer')
      })
    }
  }

  // Header Content
  basicHeaderContent(date, view) {
    const dateDM = view === 'dayGridMonth' ? '' : date.format('DD.MM')
    if (this.isMobile) {
      return {
        html: `<span class='fc-header-weekday'>${dateDM}</span> <span class='fc-header-weekday'>${date.format('ddd').toUpperCase()}</span>`
      }
    }
    return {
      html: `<span class='fc-header-date'>${dateDM}</span> <span class='fc-header-weekday'>${date.format('dddd').toUpperCase()}</span>`
    }
  }

  listHeaderContent(date) {
    return {
      html: `<span class='fc-list-heading-main'>${date.format('dddd')}</span> <span class='fc-list-heading-alt'>${date.format('LL')}</span>`
    }
  }

  // Event Loading
  loadAndFilterEvents(info, successCallback, failureCallback) {
    const params = new URLSearchParams({
      start: info.startStr,
      end: info.endStr,
      schoolId: this.calendar.data('schoolId'),
      code: this.calendar.data('schoolCode')
    })

    for (const [key, value] of Object.entries(this.filters)) {
      params.append(`filters[${key}]`, value)
    }

    fetch(`${this.origin}/external/calendar/events?${params}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then((data) => successCallback(data))
      .catch((error) => {
        console.error('Error loading events:', error)
        failureCallback(error)
      })
  }

  tooltipText(event) {
    const name = `<b>${event.title}</b><br/><br/>`
    const eventParams = event.extendedProps
    const parts = []

    if (!(this.hideGroupSize || eventParams.free_slots === null)) {
      const freeSlotsText = parseInt(eventParams.free_slots) <= 0
        ? `${TRANSLATIONS[LOCALE].no_free_slots}<br/><br/>`
        : `${TRANSLATIONS[LOCALE].free_slots}: ${eventParams.free_slots}<br/><br/>`
      parts.push(freeSlotsText)
    }

    if (eventParams.instructors) {
      parts.push(`<b>${TRANSLATIONS[LOCALE].instructors}</b>: ${eventParams.instructors} <br/>`)
    }

    if (eventParams.venue) {
      parts.push(`<b>${TRANSLATIONS[LOCALE].venue}</b>: ${eventParams.venue} <br/>`)
    }

    if (eventParams.proficiency && typeof eventParams.proficiency === 'string') {
      parts.push(`<b>${TRANSLATIONS[LOCALE].proficiency}</b>: ${eventParams.proficiency} <br/>`)
    }

    parts.push(`<b>${TRANSLATIONS[LOCALE].timing}</b>: ${eventParams.timing} <br/>`)

    return name + parts.join('')
  }

  // Event Click Handling
  eventClickFunction(obj) {
    const event = obj.event
    obj.jsEvent.preventDefault()
    if (this.signupForEventEnabled(event)) {
      const eventParams = event.extendedProps
      const params = new URLSearchParams({
        type: eventParams.type,
        groupId: event.id,
        code: this.calendar.data('schoolCode'),
        schoolId: this.calendar.data('schoolId')
      })

      fetch(`${location.origin}/external/calendar/signup_form_modal?${params}`)
        .then((response) => response.text())
        .then((html) => {
          $('#js-modal-holder').empty().append(html)
          $('#js-external-signup-form-modal').modal('show')
        })
        .catch((error) => console.error('Error loading modal:', error))
    }
  }

  signupForEventEnabled(event) {
    const eventParams = event.extendedProps
    return this.calendar.data('enableClickForSignup') &&
      this.freeSlotsExist(eventParams.free_slots) &&
      this.canSignupOn(event.start) &&
      eventParams.type !== "PersonalCyclicEvent"
  }

  freeSlotsExist(freeSlots) {
    return freeSlots > 0 || freeSlots === null
  }

  canSignupOn(date) {
    return this.minimalSignupDate
      ? dayjs(date).isSameOrAfter(this.minimalSignupDate)
      : true
  }

  // Filters and navigation
  bindEvents() {
    document.querySelectorAll('.js-change-view').forEach(element => {
      element.addEventListener('click', (e) => {
        const viewType = e.target.dataset.type
        this.fullCalendar.changeView(viewType)
        this.refreshControls()
      })
    })

    const navigationElements = {
      prev: document.querySelector('.js-btn-cal-prev'),
      next: document.querySelector('.js-btn-cal-next'),
      today: document.getElementById('js-btn-cal-today')
    }

    navigationElements.prev.addEventListener('click', () => {
      this.fullCalendar.prev()
      this.refreshControls()
    })

    navigationElements.next.addEventListener('click', () => {
      this.fullCalendar.next()
      this.refreshControls()
    })

    navigationElements.today.addEventListener('click', () => {
      this.fullCalendar.today()
      this.refreshControls()
    })

    const filterElements = {
      instructor: document.querySelector('.js-select-instructor'),
      proficiency: document.querySelector('.js-select-proficiency'),
      venue: document.querySelector('.js-select-venue'),
      weekday: document.querySelector('.js-select-weekday')
    }

    filterElements.instructor.addEventListener('change', (e) => {
      this.filters['instructor'] = e.target.value
      this.refreshEvents()
    })

    filterElements.proficiency.addEventListener('change', (e) => {
      this.filters['proficiency'] = e.target.value
      this.refreshEvents()
    })

    filterElements.venue.addEventListener('change', (e) => {
      this.filters['venueId'] = e.target.value
      this.refreshEvents()
    })

    filterElements.weekday.addEventListener('change', (e) => {
      this.filters['weekday'] = e.target.value
      this.refreshEvents()
    })

    document.querySelector('.js-clear-filters-calendar').addEventListener('click', () => {
      Object.keys(this.filters).forEach(key => delete this.filters[key])
      Object.values(filterElements).forEach(element => element.value = '')
      this.refreshEvents()
    })
  }

  // Helper Methods
  refreshControls() {
    this.updateCurrentDateHTML()
    this.sendResizeCallback()
  }

  refreshEvents() {
    this.fullCalendar.refetchEvents()
  }

  sendResizeCallback() {
    const height = document.getElementsByTagName('html')[0].scrollHeight
    window.parent.postMessage(['setCalendarHeight', height], "*")
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CalendarShowController();
});
